import { cn } from "@/lib/utils";

interface PillToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  labelOn?: string;
  labelOff?: string;
  disabled?: boolean;
  className?: string;
}

export const PillToggle = ({
  checked,
  onCheckedChange,
  labelOn = "Yes",
  labelOff = "No",
  disabled = false,
  className,
}: PillToggleProps) => {
  return (
    <div
      className={cn(
        "inline-flex h-7 items-center rounded-full bg-muted p-0.5 text-xs font-medium",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={() => onCheckedChange(false)}
        className={cn(
          "h-6 px-3 rounded-full transition-all duration-200",
          !checked
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        {labelOff}
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onCheckedChange(true)}
        className={cn(
          "h-6 px-3 rounded-full transition-all duration-200",
          checked
            ? "bg-primary text-primary-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        {labelOn}
      </button>
    </div>
  );
};
